import { Trans } from "@lingui/react";
import { Button } from "@warp-ds/elements/react/button";
import type { MouseEventHandler } from "react";
import { useAdViewAd } from "src/context/AdViewProviderContext.tsx";
import { useAppConfig } from "src/context/AppConfigProviderContext.tsx";

const HiddenAddressInfo = () => {
  const { location } = useAdViewAd();
  const { isLoggedIn, mountOrigin, originalUrl } = useAppConfig();

  if (!location || (location && !location.streetAddress)) return null;

  const showUrl = `${originalUrl}?showContactInfo=true`;

  const onClick: MouseEventHandler = (event) => {
    event.preventDefault();
    window.history.replaceState(null, "", showUrl);
    window.location.reload();
  };

  return (
    <span className="pl-16">
      {isLoggedIn ? (
        <Button onClick={onClick} variant="link" href={`${originalUrl}?showContactInfo=true`} rel="nofollow">
          <Trans id="itemPageLayout.map.hiddenAddressInfo.showAddress.link" message="Show full address" />
        </Button>
      ) : (
        <>
          <Button className="mr-4" small href={`${mountOrigin}/auth/login`} rel="nofollow">
            <Trans id="itemPageLayout.map.hiddenAddressInfo.login.link" message="Log in" />
          </Button>
          <Trans id="itemPageLayout.map.hiddenAddressInfo.login.description" message="Log in to see the address" />
        </>
      )}
    </span>
  );
};

export default HiddenAddressInfo;
